'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$$anon$71(evaluator$37) {
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$71__f_evaluator$13 = null;
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$71__f_evaluator$13 = evaluator$37;
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$$anon$71 as $c_Lapp_api_GeneralPracticeAppUpdate$$anon$71 };
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$71.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$71.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$71;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$$anon$71() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$$anon$71 as $h_Lapp_api_GeneralPracticeAppUpdate$$anon$71 };
$h_Lapp_api_GeneralPracticeAppUpdate$$anon$71.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$71.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$71.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$71.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_GeneralPracticeAppUpdate$$anon$71__f_evaluator$13.apply__O();
  return ((v !== null) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$71.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_GeneralPracticeAppUpdate$$anon$71 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$$anon$71, "app.api.GeneralPracticeAppUpdate$$anon$71", ({
  Lapp_api_GeneralPracticeAppUpdate$$anon$71: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$$anon$71 as $d_Lapp_api_GeneralPracticeAppUpdate$$anon$71 };
//# sourceMappingURL=app.api.-General-Practice-App-Update$$anon$71.js.map
